import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingAccountDetail: false
}

// getters
const getters = {
  getLoadingAccountDetail () {
    return state.loadingAccountDetail
  }
}

// actions
const actions = {
  async getAccountDetail ({ commit, rootState }, data) {
    commit('LOADING_ACCOUNT_DETAIL_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    body = Object.assign({}, {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: '',
          claveInicio: '',
          entidad: config.entidad,
          idioma: 'ES',
          indMasDatos: '',
          oficina: '',
          pantPagina: false,
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          cantpunt: 0,
          codcuent: data.idAccount,
          codentid: '',
          codprogr: appProgram,
          puntacum: 0,
          puntanuauto: 0,
          puntcadu: 0,
          puntdisp: 0,
          puntexced: 0,
          puntoanu: 0,
          puntolib: 0,
          puntpena: 0,
          puntretblo: 0,
          puntretesp: 0,
          puntretman: 0
        }
      }
    })
    try {
      const response = await HTTP.post(config.endpoints.getAccountDetail, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_ACCOUNT_DETAIL_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  }
}

// mutations
const mutations = {
  'LOADING_ACCOUNT_DETAIL_FINISHED' (state, actions) {
    state.loadingAccountDetail = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
